[
  {
    "id": "GET-E6P-L106-001",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Welk kommagetal hoort bij $\\frac{1}{4}$?",
    "options": ["0,25", "0,40", "0,50", "0,75"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen",
    "familyId": "GET-KOMMA-BREUK",
    "explanation": "Een kwart is de helft van de helft. De helft van 1 is 0,50. De helft daarvan is 0,25.",
    "distractorExplanations": {
      "1": "Dit is 4/10 of 2/5. Je hebt waarschijnlijk alleen naar de 4 onder de breukstreep gekeken.",
      "2": "Dit is een half (1/2).",
      "3": "Dit is drie kwart (3/4)."
    }
  },
  {
    "id": "GET-E6P-L106-002",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Reken uit: 2,5 + 1,75 =",
    "options": ["4,25", "3,25", "4,50", "3,75"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen_optellen",
    "familyId": "GET-KOMMA-OPTELLEN",
    "explanation": "2 + 1 = 3. 0,50 + 0,75 = 1,25. 3 + 1,25 = 4,25.",
    "distractorExplanations": {
      "1": "Je bent vergeten dat 0,50 + 0,75 meer is dan 1 hele.",
      "2": "Je hebt de 0,50 en 0,75 verkeerd gecombineerd tot 1,50.",
      "3": "Je hebt de 0,50 van het eerste getal niet meegeteld."
    }
  },
  {
    "id": "GET-E6P-L106-003",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Wat is 10% van 450?",
    "options": ["45", "4,5", "90", "450"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-TIENPROCENT",
    "explanation": "10% is een tiende deel. Je deelt door 10. 450 : 10 = 45.",
    "distractorExplanations": {
      "1": "Dat is 1%. Dan deel je door 100.",
      "2": "Dat is 20%. Je hebt het bedrag gedeeld door 5.",
      "3": "Dit is het hele bedrag (100%)."
    }
  },
  {
    "id": "GET-E6P-L106-004",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Welk getal is groter dan 3,8 maar kleiner dan 3,9?",
    "options": ["3,85", "3,75", "3,95", "3,09"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen_vergelijken",
    "familyId": "GET-KOMMA-VGL",
    "explanation": "3,8 is hetzelfde als 3,80. 3,9 is 3,90. 3,85 ligt daar precies tussenin.",
    "distractorExplanations": {
      "1": "Dat is kleiner dan 3,8 (3,75 < 3,80).",
      "2": "Dat is al groter dan 3,9 (3,95 > 3,90).",
      "3": "Pas op: 3,09 heeft 0 tienden en is dus veel kleiner dan 3,8."
    }
  },
  {
    "id": "GET-E6P-L106-005",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Reken uit: 4 $\\times$ 125 =",
    "options": ["500", "400", "600", "425"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "vermenigvuldigen",
    "familyId": "GET-KEER-HANDIG",
    "explanation": "2 $\\times$ 125 = 250. 4 $\\times$ 125 is het dubbele daarvan: 500.",
    "distractorExplanations": {
      "1": "Je hebt alleen 4 $\\times$ 100 gedaan en de rest vergeten.",
      "2": "Je hebt te veel geteld; 4 $\\times$ 125 is precies 500.",
      "3": "Je hebt de 25 achter de 4 geplakt in plaats van vermenigvuldigd."
    }
  },
  {
    "id": "GET-E6P-L106-006",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Welk kommagetal hoort bij $\\frac{3}{4}$?",
    "options": ["0,75", "0,34", "0,50", "0,25"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen",
    "familyId": "GET-KOMMA-BREUK",
    "explanation": "Drie kwart = 3 $\\times$ 0,25 = 0,75. Denk aan 75 cent van een euro.",
    "distractorExplanations": {
      "1": "Je hebt waarschijnlijk de cijfers van de breuk (3 en 4) achter de komma gezet.",
      "2": "Dit is de helft (1/2).",
      "3": "Dit is één kwart (1/4)."
    }
  },
  {
    "id": "GET-E6P-L106-007",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Reken uit: 5,30 - 2,85 =",
    "options": ["2,45", "2,55", "3,45", "2,35"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen_aftrekken",
    "familyId": "GET-KOMMA-AFTREKKEN",
    "explanation": "5,30 - 2,85: Vul aan van 2,85 naar 5,30. Van 2,85 naar 3,00 is 0,15. Van 3,00 naar 5,30 is 2,30. Samen 2,45.",
    "distractorExplanations": {
      "1": "Waarschijnlijk heb je 85 - 30 gedaan bij de hondersten in plaats van te lenen bij de helen.",
      "2": "Je bent vergeten een hele 'in te wisselen' bij het aftrekken van de hondersten.",
      "3": "Je hebt de tienden niet goed verrekend."
    }
  },
  {
    "id": "GET-E6P-L106-008",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Wat is 50% van 360?",
    "options": ["180", "36", "72", "300"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-HELFT",
    "explanation": "50% is de helft. 360 : 2 = 180.",
    "distractorExplanations": {
      "1": "Dit is 10%.",
      "2": "Dit is 20%.",
      "3": "Dit is veel meer dan de helft."
    }
  },
  {
    "id": "GET-E6P-L106-009",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Zet in de juiste volgorde van klein naar groot: 0,5 — 0,08 — 0,45",
    "options": ["0,08 — 0,45 — 0,5", "0,5 — 0,45 — 0,08", "0,08 — 0,5 — 0,45", "0,45 — 0,08 — 0,5"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen_vergelijken",
    "familyId": "GET-KOMMA-VGL",
    "explanation": "Vul aan tot honderdstes: 0,08 is 8, 0,45 is 45 en 0,5 is 50 honderdstes.",
    "distractorExplanations": {
      "1": "Dit is van groot naar klein.",
      "2": "Je dacht dat 0,5 kleiner is dan 0,45 omdat er minder cijfers staan, maar 0,5 is 0,50.",
      "3": "De 0,45 en 0,08 staan niet in de goede volgorde."
    }
  },
  {
    "id": "GET-E6P-L106-010",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Reken uit: 8 $\\times$ 75 =",
    "options": ["600", "560", "650", "575"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "vermenigvuldigen",
    "familyId": "GET-KEER-HANDIG",
    "explanation": "8 $\\times$ 75 = 8 $\\times$ 70 + 8 $\\times$ 5 = 560 + 40 = 600.",
    "distractorExplanations": {
      "1": "Je hebt 8 $\\times$ 70 gedaan, maar de 8 $\\times$ 5 vergeten.",
      "2": "Je hebt een rekenfout gemaakt bij het optellen van de twee delen.",
      "3": "Je bent vergeten dat 8 $\\times$ 5 uitkomt op een mooi rond tiental (40)."
    }
  },
  {
    "id": "GET-E6P-L106-011",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Welk kommagetal hoort bij $\\frac{1}{5}$?",
    "options": ["0,2", "0,5", "0,15", "0,25"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen",
    "familyId": "GET-KOMMA-BREUK",
    "explanation": "1 : 5 = 0,2. Je kunt ook denken aan 10 : 5 = 2, dus 1 : 5 = 0,2.",
    "distractorExplanations": {
      "1": "Dit is een half (1/2).",
      "2": "Dit getal ligt tussen 1/10 en 2/10 in.",
      "3": "Dit is een kwart (1/4)."
    }
  },
  {
    "id": "GET-E6P-L106-012",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Wat is 25% van 200?",
    "options": ["50", "25", "75", "100"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "procenten",
    "subSkill": "procenten",
    "familyId": "GET-PROC-KWART",
    "explanation": "25% is een kwart. De helft van 200 is 100, de helft daarvan is 50.",
    "distractorExplanations": {
      "1": "Dit is 12,5%. Je hebt waarschijnlijk door 8 gedeeld.",
      "2": "Dit is 37,5% (drie achtste deel).",
      "3": "Dit is 50%. Je hebt de helft genomen in plaats van een kwart."
    }
  },
  {
    "id": "GET-E6P-L106-013",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Reken uit: 3,60 + 4,75 =",
    "options": ["8,35", "7,35", "8,25", "7,75"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen_optellen",
    "familyId": "GET-KOMMA-OPTELLEN",
    "explanation": "3 + 4 = 7. 0,60 + 0,75 = 1,35 (60 + 75 honderdstes). 7 + 1,35 = 8,35.",
    "distractorExplanations": {
      "1": "Je bent de extra 1 vergeten die ontstaat bij 0,60 + 0,75.",
      "2": "Je hebt een foutje gemaakt bij het optellen van de tienden.",
      "3": "Je hebt de honderdstes niet goed bij de helen opgeteld."
    }
  },
  {
    "id": "GET-E6P-L106-014",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Reken uit: 6 $\\times$ 250 =",
    "options": ["1500", "1200", "1800", "1250"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "basisrekenen",
    "subSkill": "vermenigvuldigen",
    "familyId": "GET-KEER-HANDIG",
    "explanation": "4 $\\times$ 250 = 1000. 2 $\\times$ 250 = 500. Samen 1500.",
    "distractorExplanations": {
      "1": "Je bent waarschijnlijk twee keer 250 vergeten.",
      "2": "Je hebt 6 $\\times$ 300 gerekend.",
      "3": "Je hebt 5 $\\times$ 250 gerekend."
    }
  },
  {
    "id": "GET-E6P-L106-015",
    "module": "Getalbegrip",
    "difficulty": 106,
    "question": "Welk getal is het grootst?",
    "options": ["0,7", "0,65", "0,07", "0,69"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "kommagetallen",
    "subSkill": "kommagetallen_vergelijken",
    "familyId": "GET-KOMMA-VGL",
    "explanation": "Maak de getallen even lang door een 0 toe te voegen: 0,70 is groter dan 0,65 en 0,69.",
    "distractorExplanations": {
      "1": "Hoewel 65 een hoger getal lijkt dan 7, gaat het om de tienden. 7 tienden (0,70) is meer dan 6 tienden.",
      "2": "Dit zijn 7 honderdsten, dat is tien keer zo klein als 0,7.",
      "3": "Dit is bijna 0,70, maar 0,7 is net iets groter."
    }
  }
]